// When the escrow gate bypass may be engaged.
//
// Owner ruling, 2026-10-09: once the deal's escrow succeeded (released, on
// either model) the test bypass is no longer needed, so it cannot be engaged.
// That limit is the GUI's own; the API still re-affirms a prior bypass.
//
// Owner ruling, 2026-10-26: the bypass is available only when the deal has had
// no real escrow activity, pending or succeeded. The API refuses that itself,
// and GET …/escrow/status carries its refusal sentence (bypassBlockedReason),
// computed by the same server predicate, so the browser shows exactly what the
// server would answer. Both entry points — Underwriting Section 2 and the admin
// console — read it from there.

import type { DealEscrowStatusDto } from "@/api/dealFlow/types";

export const ESCROW_RELEASED_BYPASS_MESSAGE =
  "This deal's escrow is already released, so the test bypass is not needed and cannot be engaged.";

/** The reason the bypass is unavailable, or null when it may be engaged. */
export function escrowBypassBlockedReason(
  status: DealEscrowStatusDto | undefined,
): string | null {
  if (status?.released) return ESCROW_RELEASED_BYPASS_MESSAGE;
  const serverReason = status?.bypassBlockedReason?.trim();
  return serverReason ? serverReason : null;
}
